import PropTypes from 'prop-types';
import React from 'react';
import CheckboxSwitch from '../../../common/checkboxSwitch';
import AdminSaveButton from '../../shared/Buttons/AdminSaveButton';

const BrandSubscriptionOptions = ({ handleSubmit, submitting }) => (
  <form onSubmit={handleSubmit} className="u-mb">
    <h5 className="u-mt u-mb-">Enabled features</h5>
    <div className="layout u-mt">
      <CheckboxSwitch name="campaignsEnabled" label="Engage" id="campaignsEnabled" wrapperClass="layout__item u-1/2" />
      <CheckboxSwitch name="commissionReportingEnabled" label="Commission reports" id="commissionReportingEnabled" wrapperClass="layout__item u-1/2" />
      <CheckboxSwitch name="productReportingEnabled" label="Product reports" id="productReportingEnabled" wrapperClass="layout__item u-1/2" />
      <CheckboxSwitch name="customReportingEnabled" label="Custom reports enterprise" id="customReportingEnabled" wrapperClass="layout__item u-1/2" />
      <CheckboxSwitch name="chatEnabled" label="Chat" id="chatEnabled" wrapperClass="layout__item u-1/2" />
      <CheckboxSwitch name="conversionTracking" label="Conversion Tracking" id="conversionTracking" wrapperClass="layout__item u-1/2" />
      <div className='layout__item'>
        <AdminSaveButton disabled={submitting} content="Save" />
      </div>
    </div>
  </form>
);

BrandSubscriptionOptions.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

export default BrandSubscriptionOptions;
